import { useEffect, useState } from 'react';

/**
 * Track whether the viewport is narrower than a mobile breakpoint.
 *
 * Mirrors `window.innerWidth < breakpoint` and keeps it in sync via a
 * `resize` listener.  Extracted from WorkflowBuilder so the responsive
 * behaviour is reusable and unit-testable in isolation.
 *
 * @param {number} breakpoint - Max width (px) treated as "mobile".
 * @returns {boolean} True while the viewport is below `breakpoint`.
 */
export function useIsMobile(breakpoint = 1024) {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < breakpoint,
  );

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < breakpoint);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, [breakpoint]);

  return isMobile;
}
